export function isReferralsEnabled(): boolean {
  return process.env.NEXT_PUBLIC_REFERRALS_ENABLED === 'true'
}

export function isGutHealthBarEnabled(): boolean {
  return process.env.NEXT_PUBLIC_GUT_HEALTH_BAR_ENABLED === 'true'
}

export function isAttributionMintEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ATTRIBUTION_MINT_ENABLED === 'true'
}

export function isLeadIdPropagationEnabled(): boolean {
  return process.env.NEXT_PUBLIC_LEAD_ID_PROPAGATION_ENABLED === 'true'
}
